export const isFormFieldVisible = (field, values = {}) => {
    if (!field) {
        return false;
    }
    if (field.isView === false) {
        return false;
    }
    let cascadeShowKey = field.id + '-casDefautShow';
    if (Object.prototype.hasOwnProperty.call(values, cascadeShowKey)) {
        return !!values[cascadeShowKey];
    }
    return field.ext2 !== '1';
};

export const isRequiredFormFieldVisible = (field, values = {}) => {
    return !!(field && field.isView && field.options && field.options.required && isFormFieldVisible(field, values));
};

export const resetCascadeFieldVisible = (fieldsList = [], values = {}) => {
    if (!Array.isArray(fieldsList) || !values) {
        return;
    }
    let cascadeFieldIds = new Set();
    let showFieldIds = new Set();
    let fieldsMap = new Map();
    fieldsList.forEach(field => {
        if (field && field.id) {
            fieldsMap.set(field.id, field);
        }
    });
    fieldsList.forEach(field => {
        let config = field && field.options && field.options.config;
        let options = config && config.options;
        let isCascadeControlField = field && (field.type === 'select' || (field.type === 'category' && config && config.type === 'single')) && field.ext2 !== '1';
        if (!isCascadeControlField || !Array.isArray(options)) {
            return;
        }
        let fieldValue = values[field.id];
        options.forEach(option => {
            if (!option || !option.ext3) {
                return;
            }
            let isSelectedOption = option.value == fieldValue;
            option.ext3.split(',').forEach(fieldId => {
                if (!fieldId) {
                    return;
                }
                cascadeFieldIds.add(fieldId);
                if (isSelectedOption) {
                    showFieldIds.add(fieldId);
                }
            });
        });
    });
    cascadeFieldIds.forEach(fieldId => {
        let isShow = showFieldIds.has(fieldId);
        values[fieldId + '-casDefautShow'] = isShow;
        let targetField = fieldsMap.get(fieldId);
        if (targetField) {
            targetField.isView = isShow;
        }
    });
};



// WEBPACK FOOTER //
// ./src/utils/form-required.js